import { TrackingProvider } from './tracking-provider';

type DatadomeWindow = Window &
	typeof globalThis & {
		ddjskey: string;
		ddoptions: any;
	};
export class DatadomeTag extends TrackingProvider {
	required = true;
	dataProcessingService = null;

	constructor() {
		super();
	}

	initialize(): Promise<void> {
		return new Promise<void>(resolve => {
			(window as DatadomeWindow).ddjskey = '705CE572A13C868C0D28BFD3ABA2D3';
			// Add configuration here
			(window as DatadomeWindow).ddoptions = {};

			const f = document.getElementsByTagName('script')[0],
				j = document.createElement('script');
			j.async = true;
			j.src = 'https://js.datadome.co/tags.js';

			f.parentNode!.insertBefore(j, f);

			resolve();
		});
	}

	async trackEvent() {}
	async trackPage() {}

	refreshPermanentAudiences() {}
	refreshPermanentAudiencesSubgenres() {}
}
